import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const MenuUnfoldIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "menu-unfold",
  "MenuUnfoldIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M14.6665 2.66663H1.33317V3.99996H14.6665V2.66663Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M9.33301 7.33331H1.33301V8.66665H9.33301V7.33331Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M14.6665 12.0001H1.33317V13.3334H14.6665V12.0001Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M10.6963 8.00009L14.4467 10.3954L14.4467 5.60474L10.6963 8.00009Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default MenuUnfoldIcon;
